"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleSocialLinkedin.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleSocialLinkedin = function CircleSocialLinkedin(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 515 515"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "LinkedIn Icon"), _react2.default.createElement("path", {
    className: "linkedin",
    d: "M257.5 0C115.29 0 0 115.29 0 257.5S115.29 515 257.5 515 515 399.71 515 257.5 399.71 0 257.5 0zm-64.33 373.77h-48.32V218.44h48.32v155.33zM169 197.22a28 28 0 1 1 28-28 28 28 0 0 1-28 28zm205 176.55h-48.29v-75.54c0-18-.31-41.19-25.08-41.19-25.12 0-29 19.63-29 39.9v76.83h-48.17V218.44h46.28v21.23h.66c6.44-12.21 22.19-25.09 45.68-25.09 48.88 0 57.91 32.16 57.91 74v85.19z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = CircleSocialLinkedin;